import { useLang } from "@/i18n/LanguageContext";
import { Check } from "lucide-react";
import aiMock from "@/assets/ai-coach-mock.jpg";

const toneBg: Record<string, string> = {
  mint: "bg-mint text-mint-foreground",
  coral: "bg-coral text-coral-foreground",
  butter: "bg-butter text-butter-foreground",
  lavender: "bg-lavender text-lavender-foreground",
};

const AiHouseSection = () => {
  const { t } = useLang();
  return (
    <section id="ai" className="py-24 md:py-32 bg-soft">
      <div className="container">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-primary-glow">{t.ai.eyebrow}</span>
            <h2 className="mt-3 text-3xl sm:text-4xl md:text-6xl font-extrabold leading-[1.05]">{t.ai.title}</h2>
            <p className="mt-5 text-lg md:text-xl text-muted-foreground leading-relaxed">{t.ai.desc}</p>
            <ul className="mt-8 space-y-3">
              {t.ai.bullets.map((b) => (
                <li key={b} className="flex items-start gap-3">
                  <span className="mt-0.5 inline-flex h-6 w-6 items-center justify-center rounded-full bg-primary text-primary-foreground shrink-0">
                    <Check className="h-3.5 w-3.5" />
                  </span>
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-7 space-y-6">
            <div className="rounded-3xl overflow-hidden bg-background shadow-elegant border border-border">
              <img
                src={aiMock}
                alt={t.ai.mockAlt}
                width={1280}
                height={1280}
                loading="lazy"
                className="w-full h-auto"
              />
            </div>

            <div className="grid sm:grid-cols-2 gap-4">
              {t.ai.modules.map((m) => (
                <div key={m.title} className={`rounded-3xl p-6 ${toneBg[m.tone]}`}>
                  <div className="text-xs font-bold uppercase tracking-widest opacity-70">AI</div>
                  <div className="mt-2 text-xl font-extrabold leading-tight">{m.title}</div>
                  <p className="mt-2 text-sm opacity-80">{m.desc}</p>
                </div>
              ))}
            </div>

            <div className="rounded-3xl bg-background border border-border shadow-card p-6">
              <div className="text-xs font-bold uppercase tracking-widest text-muted-foreground">{t.ai.planTitle}</div>
              <ul className="mt-4 space-y-3">
                {t.ai.planItems.map((p) => (
                  <li key={p.when} className="flex items-start gap-4">
                    <div className="shrink-0 rounded-full bg-secondary text-foreground text-xs font-bold px-3 py-1">{p.when}</div>
                    <div className="text-sm">{p.what}</div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AiHouseSection;
